module.exports = require("uuid/v4");


//////////////////
// WEBPACK FOOTER
// external "uuid/v4"
// module id = 11
// module chunks = 0